const toRgb = (hex) => {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return { r: 62, g: 141, b: 255 };
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
};

const toHex = ({ r, g, b }) => {
  const clamp = (n) => Math.round(Math.max(0, Math.min(255, n))).toString(16).padStart(2, "0");
  return `#${clamp(r)}${clamp(g)}${clamp(b)}`;
};

const mix = (hex, target, amount) => {
  const a = toRgb(hex);
  const b = toRgb(target);
  return toHex({
    r: a.r + (b.r - a.r) * amount,
    g: a.g + (b.g - a.g) * amount,
    b: a.b + (b.b - a.b) * amount,
  });
};

export const lighten = (hex, amount = 0.3) => mix(hex, "#ffffff", amount);
export const darken  = (hex, amount = 0.4) => mix(hex, "#000000", amount);
